import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const RED = '#9D1515';

export default function ContactPage() {
  useEffect(() => {
    const root = document.getElementById('root');
    document.documentElement.style.overflow = 'auto';
    document.documentElement.style.height = 'auto';
    document.body.style.overflow = 'auto';
    document.body.style.height = 'auto';
    if (root) { root.style.overflow = 'auto'; root.style.height = 'auto'; }
    window.scrollTo(0, 0);
    return () => {
      document.documentElement.style.overflow = '';
      document.documentElement.style.height = '';
      document.body.style.overflow = '';
      document.body.style.height = '';
      if (root) { root.style.overflow = ''; root.style.height = ''; }
    };
  }, []);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [topic, setTopic] = useState('general');
  const [status, setStatus] = useState('idle'); // idle | sending | sent | error
  const [errorMsg, setErrorMsg] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim() || !email.trim() || !message.trim()) {
      setStatus('error'); setErrorMsg('Please fill in name, email, and message.');
      return;
    }
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.trim())) {
      setStatus('error'); setErrorMsg('Please enter a valid email address.');
      return;
    }
    setStatus('sending'); setErrorMsg('');
    try {
      const res = await fetch(
        `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/send-contact-email`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'apikey': process.env.REACT_APP_SUPABASE_ANON_KEY,
            'Authorization': `Bearer ${process.env.REACT_APP_SUPABASE_ANON_KEY}`,
          },
          body: JSON.stringify({
            name: name.trim(),
            email: email.trim(),
            topic,
            message: message.trim(),
          }),
        },
      );
      const result = await res.json().catch(() => ({}));
      if (!res.ok || result.error) {
        setStatus('error');
        setErrorMsg(result.error || 'Could not send your message. Email us directly at ovrleague@gmail.com.');
        return;
      }
      setStatus('sent');
      setName(''); setEmail(''); setMessage('');
    } catch (err) {
      setStatus('error');
      setErrorMsg('Network error. Email us directly at ovrleague@gmail.com.');
    }
  };

  const inputStyle = {
    width: '100%', boxSizing: 'border-box',
    padding: '12px 14px', background: '#0e0e0e',
    border: '1px solid #2a2a2a', color: '#fff',
    fontFamily: 'Inter, sans-serif', fontSize: 13,
    outline: 'none', transition: 'border-color 0.15s',
  };
  const labelStyle = {
    fontFamily: "'Bebas Neue','Oswald',sans-serif",
    fontSize: 11, letterSpacing: '0.18em',
    color: '#9D1515', display: 'block', marginBottom: 8, textTransform: 'uppercase',
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: '#0a0a0a', color: '#e8e8e8',
      fontFamily: "'Inter', system-ui, sans-serif",
      padding: '60px 24px 80px',
    }}>
      <div style={{ maxWidth: 880, margin: '0 auto' }}>
        <Link to="/" style={{
          fontFamily: "'Bebas Neue','Oswald',sans-serif",
          fontSize: 13, letterSpacing: '0.16em',
          color: RED, textDecoration: 'none',
        }}>← OVR LEAGUE</Link>

        <p style={{ fontFamily: 'Inter, sans-serif', fontSize: 11, fontWeight: 700, letterSpacing: '0.22em', color: RED, margin: '40px 0 12px', textTransform: 'uppercase' }}>
          Get In Touch
        </p>
        <h1 style={{
          fontFamily: "'Bebas Neue','Oswald',sans-serif",
          fontSize: 'clamp(48px, 8vw, 84px)',
          color: '#fff', margin: 0, letterSpacing: '0.03em', lineHeight: 0.95,
        }}>
          CONTACT <em style={{ color: RED, fontStyle: 'italic' }}>OVR</em>
        </h1>
        <p style={{ fontSize: 15, color: 'rgba(255,255,255,0.55)', marginTop: 16, maxWidth: 540, lineHeight: 1.6 }}>
          Questions about registration, sponsorships, refunds, or just want to say hi? Drop us a line.
          We usually get back within 24 hours.
        </p>

        <div style={{
          marginTop: 48,
          display: 'grid',
          gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1.4fr)',
          gap: 40,
        }} className="contact-grid">
          <style>{`
            @media (max-width: 720px) {
              .contact-grid { grid-template-columns: 1fr !important; gap: 28px !important; }
            }
          `}</style>

          {/* Left column: Direct contact */}
          <div>
            <h2 style={{
              fontFamily: "'Bebas Neue','Oswald',sans-serif",
              fontSize: 20, color: '#fff', letterSpacing: '0.1em',
              borderBottom: `1px solid ${RED}`, paddingBottom: 8, margin: '0 0 18px',
            }}>
              DIRECT CHANNELS
            </h2>
            {[
              { label: 'Email', value: 'ovrleague@gmail.com', href: 'mailto:ovrleague@gmail.com' },
              { label: 'Instagram', value: '@ovrleague', href: 'https://www.instagram.com/ovrleague' },
              { label: 'Facebook', value: 'OVR League', href: 'https://www.facebook.com/ovrleague' },
            ].map(c => (
              <a key={c.label} href={c.href} target="_blank" rel="noopener noreferrer" style={{
                display: 'block', textDecoration: 'none',
                background: '#0e0e0e', border: '1px solid #1f1f1f', borderLeft: `3px solid ${RED}`,
                padding: '14px 18px', marginBottom: 12,
                transition: 'background 0.15s',
              }}
              onMouseEnter={e => e.currentTarget.style.background = '#141414'}
              onMouseLeave={e => e.currentTarget.style.background = '#0e0e0e'}
              >
                <div style={{ fontSize: 10, letterSpacing: '0.18em', color: '#888', textTransform: 'uppercase', marginBottom: 4 }}>
                  {c.label}
                </div>
                <div style={{ fontSize: 14, fontWeight: 600, color: '#fff' }}>
                  {c.value}
                </div>
              </a>
            ))}
            <div style={{ marginTop: 24, fontSize: 12, color: '#666', lineHeight: 1.6 }}>
              Based in Ottawa, Ontario. We respond fastest on Instagram DMs.
            </div>
          </div>

          {/* Right column: Form */}
          <div>
            <h2 style={{
              fontFamily: "'Bebas Neue','Oswald',sans-serif",
              fontSize: 20, color: '#fff', letterSpacing: '0.1em',
              borderBottom: `1px solid ${RED}`, paddingBottom: 8, margin: '0 0 18px',
            }}>
              SEND A MESSAGE
            </h2>

            {status === 'sent' ? (
              <div style={{
                background: 'rgba(74,222,128,0.08)',
                border: '1px solid rgba(74,222,128,0.35)',
                borderLeft: '3px solid #4ade80',
                padding: '20px 22px',
              }}>
                <div style={{ fontFamily: "'Bebas Neue','Oswald',sans-serif", fontSize: 18, letterSpacing: '0.1em', color: '#4ade80', marginBottom: 6 }}>
                  MESSAGE SENT
                </div>
                <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.7)', margin: 0, lineHeight: 1.55 }}>
                  Thanks for reaching out. We'll get back to you within 24 hours.
                </p>
                <button onClick={() => setStatus('idle')} style={{
                  marginTop: 14, background: 'transparent',
                  border: '1px solid rgba(255,255,255,0.2)', color: '#fff',
                  fontFamily: "'Bebas Neue','Oswald',sans-serif",
                  fontSize: 11, letterSpacing: '0.14em',
                  padding: '8px 14px', cursor: 'pointer',
                }}>
                  SEND ANOTHER
                </button>
              </div>
            ) : (
              <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                <div>
                  <label style={labelStyle}>Your Name</label>
                  <input style={inputStyle} value={name} onChange={e => setName(e.target.value)} maxLength={120} required />
                </div>
                <div>
                  <label style={labelStyle}>Email</label>
                  <input style={inputStyle} type="email" value={email} onChange={e => setEmail(e.target.value)} maxLength={200} required />
                </div>
                <div>
                  <label style={labelStyle}>Topic</label>
                  <select style={inputStyle} value={topic} onChange={e => setTopic(e.target.value)}>
                    <option value="general">General Question</option>
                    <option value="registration">Registration / Sign-up</option>
                    <option value="refund">Refund Request</option>
                    <option value="sponsorship">Sponsorship Inquiry</option>
                    <option value="feedback">Feedback</option>
                    <option value="other">Other</option>
                  </select>
                </div>
                <div>
                  <label style={labelStyle}>Message</label>
                  <textarea
                    style={{ ...inputStyle, minHeight: 140, resize: 'vertical', fontFamily: 'Inter, sans-serif' }}
                    value={message} onChange={e => setMessage(e.target.value)} maxLength={4000} required
                  />
                </div>
                {status === 'error' && (
                  <div style={{ fontSize: 12, color: '#ff6b6b', padding: '8px 12px', background: 'rgba(255,107,107,0.08)', border: '1px solid rgba(255,107,107,0.3)' }}>
                    {errorMsg}
                  </div>
                )}
                <button
                  type="submit"
                  disabled={status === 'sending'}
                  style={{
                    background: RED, color: '#fff', border: 'none',
                    fontFamily: "'Bebas Neue','Oswald',sans-serif",
                    fontSize: 14, letterSpacing: '0.18em',
                    padding: '14px 24px', cursor: status === 'sending' ? 'not-allowed' : 'pointer',
                    opacity: status === 'sending' ? 0.6 : 1, marginTop: 4,
                  }}
                >
                  {status === 'sending' ? 'SENDING...' : 'SEND MESSAGE →'}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
